"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorHandler = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _axios = _interopRequireDefault(require("axios"));
var _brandContext = require("../../contextProviders/brandContext");
var _storageKeys = require("../../constants/app/storageKeys");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var consecutiveErrorsThreshold = 30;
var numberConsecutiveErrors = 0;
var ErrorHandler = exports.ErrorHandler = function ErrorHandler(_ref) {
  var children = _ref.children;
  var navigate = (0, _reactRouterDom.useNavigate)();
  var _useContext = (0, _react.useContext)(_brandContext.BrandContext),
    env = _useContext.env;
  var handleError = (0, _react.useCallback)(function (event) {
    if (_axios["default"].isCancel(event)) {
      /* Exclude errors thrown by requests that have been cancelled */
      return;
    }
    var isUnhandledRejectionEvent = !!event.type && event.type === 'unhandledrejection';
    var silentErrorNames = ['NavigateWhileActionExecutingError'];
    if (isUnhandledRejectionEvent) {
      var errorName = event.reason.name;
      if (silentErrorNames.includes(errorName)) {
        return;
      }
    }

    /* eslint-disable-next-line no-console */
    console.error('An error has been caught: ', event);
    sessionStorage.removeItem(_storageKeys.QUOTE_REFERENCE);
    navigate('/error');
  }, [navigate]);
  var handleErrorEventCallback = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    event.stopPropagation();
    numberConsecutiveErrors += 1;

    // Reset consecutive errors count after handle error
    setTimeout(function () {
      numberConsecutiveErrors = 0;
    }, 100);
    if (numberConsecutiveErrors >= consecutiveErrorsThreshold) {
      return false;
    }
    return true;
  }, []);
  var registerErrorListeners = (0, _react.useCallback)(function () {
    var _window, _window2;
    var errorListener = (_window = window) === null || _window === void 0 ? void 0 : _window.addEventListener('error', handleErrorEventCallback);
    var promiseErrorListener = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.addEventListener('unhandledrejection', handleErrorEventCallback);
    return function () {
      var _window3, _window4;
      (_window3 = window) === null || _window3 === void 0 || _window3.removeEventListener('error', errorListener);
      (_window4 = window) === null || _window4 === void 0 || _window4.removeEventListener('unhandledrejection', promiseErrorListener);
    };
  }, [handleErrorEventCallback]);
  (0, _react.useEffect)(function () {
    var unregisterListeners;
    return function () {
      if (unregisterListeners) {
        unregisterListeners();
      }
    };
  }, [env, registerErrorListeners]);
  return /*#__PURE__*/_react["default"].createElement("div", null, children);
};
ErrorHandler.propTypes = {
  children: _propTypes["default"].node
};